<template>
  <div class="clients-form-page">
    <b-loading :is-full-page="false" :active.sync="isSaving"></b-loading>
    <app-page-header :title="`${clientId ? 'Editar' : 'Cadastrar'} Usuário`">
      <button
        v-app-button.icon-left.clear
        v-app-back-button="{ name: 'clients.index' }"
      >
        <b-icon size="is-small" icon="arrow-left" />Voltar
      </button>
    </app-page-header>
    <app-card>
      <clients-form
        @submit="onSubmit"
        :id="clientId"
        :errors="errors"
        :saving="isSaving"
      ></clients-form>

      <div v-if="clientId">
        <div class="points-header">
          <h2>Extrato de pontos</h2>
          <button
            @click="exportTransactions()"
            :disabled="isExporting"
            class="export-btn"
            v-app-button.icon-left
          >
            <b-icon size="is-small" icon="download" />EXPORTAR
          </button>
        </div>
        <points-extract-table :id="clientId" />
      </div>
    </app-card>
  </div>
</template>

<script>
import ClientsForm from '@/components/Forms/ClientsForm.vue';
import PointsExtractTable from '@/components/Tables/PointsExtractTable.vue';
import ClientService from '@/services/client.service';
import RankingService from '@/services/ranking.service';
import ToastMixin from '@/mixins/ToastifyMixin';

export default {
  name: 'clients-form-page',
  mixins: [ToastMixin],
  props: [],
  components: {
    ClientsForm,
    PointsExtractTable,
  },
  data: () => {
    return {
      clientId: null,
      errors: {},
      ranking: {},
      isSaving: false,
      isExporting: false,
    };
  },
  methods: {
    onSubmit(data) {
      this.errors = {};
      !this.clientId && this.save(data);
      this.clientId && this.update(this.clientId, data);
    },
    save(data) {
      this.isSaving = true;
      ClientService.save(data)
        .then(() => {
          this.toastify('Usuário cadastrado com sucesso!');
          this.$router.push({ name: 'clients.index' });
        })
        .catch(({ response }) => {
          const { message, errors } = response.data;

          if (response.status === 422) this.errors = errors;
          else
            this.toastify(
              message || 'Erro ao tentar cadastrar Usuário.',
              'error'
            );
        })
        .finally(() => (this.isSaving = false));
    },
    update(id, data) {
      this.isSaving = true;
      ClientService.update(id, data)
        .then(() => {
          this.toastify('Usuário atualizado com sucesso!');
          this.$router.push({ name: 'clients.index' });
        })
        .catch(({ response }) => {
          const { message, errors } = response.data;

          if (response.status === 422) this.errors = errors;
          else
            this.toastify(
              message || 'Erro ao tentar atualizar Usuário.',
              'error'
            );
        })
        .finally(() => (this.isSaving = false));
    },
    loadRanking() {
      RankingService.getClientRanking(this.clientId).then((response) => {
        this.ranking = response.data;
      });
    },
    exportTransactions() {
      this.isExporting = true;

      ClientService.exportTransactions(this.clientId)
        .then(({ data }) => {
          const link = document.createElement('a');
          link.target = '_blank';
          link.href = data.url;
          link.click();
        })
        .catch(({ response }) => {
          this.toastify(
            response.data.message || 'Erro ao realizar exportação.',
            'error'
          );
        })
        .finally(() => (this.isExporting = false));
    },
  },
  beforeMount() {
    this.clientId = this.$route.params.id;
    if (this.clientId) this.loadRanking();
  },
};
</script>

<style lang="scss" scoped>
h2 {
  font-size: 2em;
  font-weight: bold;
  text-align: center;
  margin: 1em 0;
}

.points-header {
  button {
    float: right;
  }
}

.ranking {
  display: flex;
  align-items: center;
  justify-content: center;

  div {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    width: 10em;
    padding: 1em;
    border: 2px solid var(--color-primary);
    border-radius: 8px;

    &:first-child {
      margin-right: 4em;
    }

    span {
      font-size: 1.5em;
    }

    p {
      font-size: 2em;
      font-weight: bold;
    }
  }
}
</style>
